import { Lambda } from "../../common/services/http-service";

const useCognito = () => {
    const cognitoAdminRecovery = async (username) => {
        const body = {
            username: username,
            soporte: true
        };

        return await Lambda({ resource: 'cognito-admin/recupera', method: "POST", isPublic: true, data: JSON.stringify(body) });
    };

    const cognitoAdminConfirmRecovery = async (username, password, code) => {
        const body = {
            username: username,
            password: password,
            code: code
        };

        return await Lambda({ resource: 'cognito-admin/recupera', method: "PUT", isPublic: true, data: JSON.stringify(body) });
    };

    const cognitoAdminConfimar = async (username, password, code) => {
        const body = {
            username: username,
            password: password,
            code: code
        };

        return await Lambda({ resource: 'cognito-admin/confirma', method: "POST", isPublic: true, data: JSON.stringify(body) });
    };

    return {
        cognitoAdminRecovery,
        cognitoAdminConfirmRecovery,
        cognitoAdminConfimar
    }
};

export default useCognito;